import Image from 'next/image';
import Link from 'next/link';
import {
  getCommunityPath,
  getForumPath,
  getHelpCenterPath,
  getPrivacyPolicyPath,
  getToSPath,
} from 'lib/community';
import { join } from 'lib/helpers';
import styles from './SiteFooter.module.css';

const socialLinks = [
  { label: 'Discord', href: 'https://discord.com/invite/FGjmaTr' },
  {
    label: 'YouTube',
    href: 'https://www.youtube.com/channel/UCPal2R1FxwRTPylhP_7ofEg',
  },
  { label: 'X', href: 'https://twitter.com/rive_app' },
  { label: 'Instagram', href: 'https://www.instagram.com/rive.app/' },
  { label: 'Dribbble', href: 'https://dribbble.com/rive_app' },
  { label: 'GitHub', href: 'https://github.com/rive-app' },
];

/** Site-wide footer for the site refresh; replaces the Framer embed. */
export default function SiteFooter() {
  return (
    <footer className={join(['site-refresh', styles.Footer])}>
      <div className={styles.Inner}>
        <div className={styles.Top}>
          <a href="/" aria-label="Rive" className={styles.Logo}>
            <Image
              src="/static/rive_wordmark_white.svg"
              alt=""
              width={135}
              height={24}
            />
          </a>
          <div className={styles.Columns}>
            <nav aria-label="Rive" className={styles.Column}>
              <div className={styles.Label}>Rive</div>
              <a href="/">About</a>
              <Link href={getCommunityPath()}>Marketplace</Link>
              <a href={getForumPath()}>Community</a>
              <a href={getHelpCenterPath()}>Docs</a>
            </nav>
            <nav aria-label="Follow Rive" className={styles.Column}>
              <div className={styles.Label}>Follow</div>
              <div className={styles.Social}>
                {socialLinks.map((link) => (
                  <a
                    key={link.label}
                    href={link.href}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {link.label}
                  </a>
                ))}
              </div>
            </nav>
          </div>
        </div>
        <div className={styles.Bottom}>
          <span>© {new Date().getFullYear()} Rive</span>
          <div className={styles.Legal}>
            <a href={getToSPath()}>Terms of service</a>
            <a href={getPrivacyPolicyPath()}>Privacy policy</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
